import React from 'react';

// Agent markdown can carry prompt-injected schemes (javascript:, data:, …)
// and protocol-relative hosts (//evil.com). Only http(s) and single-slash
// root-relative paths stay clickable — `(?!\/)` rejects `//…`.
// Register this for BOTH the `link` and `linkReference` renderers: inline and
// reference-style links resolve through separate react-markdown renderers,
// and the default linkReference would skip this allowlist.
export const safeMarkdownLink = ({ href, children }) => {
  if (typeof href !== 'string' || !/^(https?:|\/(?!\/))/i.test(href)) {
    return <span className='ap-message-link'>{children}</span>;
  }
  return href.startsWith('/') ? (
    <a href={href} className='ap-message-link'>{children}</a>
  ) : (
    <a href={href} className='ap-message-link' target='_blank' rel='noopener noreferrer'>{children}</a>
  );
};
